import type { CaseReducer, PayloadAction } from '@reduxjs/toolkit';

import type { Member, MemberListItem } from '../../../types';
import type { State } from './slice';

export const setMember: CaseReducer<State, PayloadAction<Member>> = (
  state,
  action,
) => action.payload;

export const setSlug: CaseReducer<State, PayloadAction<string>> = (
  state,
  action,
) => ({
  ...state,
  slug: action.payload,
});

export const setBlockedMembers: CaseReducer<
  State,
  PayloadAction<MemberListItem[]>
> = (state, action) => {
  state.blockedMembers = action.payload;
};
